/* ================================================== */
/* FANCYBOX > Video
/* ================================================== */

function getElScrollPosition(el) {
	var viewportOffset = el[0].getBoundingClientRect(),
		top  = viewportOffset.y,
		left = viewportOffset.x;
	return [top, left];
}

$(document).ready(function() {

	var $video     = $('[data-fancybox="video"]'),
		tlTw       = new TimelineLite(),
		tlDuration = 0.4;

	 $video.fancybox({
		margin: [0, 0],
		gutter: 0,
		arrows: false,
		infobar: false,
		toolbar: true,
		buttons: ['close'],
		touch: false,
		youtube: {
			autoplay: 1,
			rel     : 0,
			controls: 0,
			showinfo: 0,
			color   : 'e20f1a'
		},
		vimeo: {
			autoplay: 1,
			byline  : 0,
			title   : 0,
			portrait: 0,
			color   : 'e20f1a'
		},
		baseTpl:
		'<div class="fancybox-container" role="dialog" tabindex="-1">' +
			'<div class="fancybox-bg"></div>' +
			'<div class="fancybox-inner">' +
				'<div class="fancybox-toolbar">{{buttons}}</div>' +
				'<div class="fancybox-stage"></div>' +
			'</div>' +
		'</div>',
		beforeShow: function() {
			if (!$('.fancybox-shadow').length) {
				$('body').append('<div class="fancybox-shadow"></div>');
			}

			$('.fancybox-shadow').css({
				top: getElScrollPosition($video)[0] + 'px',
				left: getElScrollPosition($video)[1] + 'px',
				width : $video.width() + 'px',
				height: $video.height() + 'px'
			});

			tlTw.set('.fancybox-shadow', {
					top   : getElScrollPosition($video)[0],
					left  : getElScrollPosition($video)[1],
					width : $video.width(),
					height: $video.height()
				})
				.set('.carousel--jumbotron, .fancybox-shadow', {
					className: '+=active'
				})
				.set('#navbar', {
					className: '+=on-scroll'
				})
				.set('.fancybox-container', {
					opacity: 1
				}, tlDuration*1.25)
				.play();
		},
		afterShow: function() {
			var $content = $('.fancybox-slide--iframe .fancybox-content'),
				loading  = '<div class="loading loading--reverse loading--fullscreen"><span>.</span><span>.</span><span>.</span></div>';
			$content.append(loading);
			$('iframe', $content).load(function() {
				$(this).addClass('visible');
			});
		},
		afterClose: function() {
			tlTw.to('.fancybox-shadow', tlDuration, {
					top   : getElScrollPosition($video)[0],
					left  : getElScrollPosition($video)[1],
					width : $video.width(),
					height: $video.height(),
					ease: Power1.easeInOut
				})
				.set('#navbar', {
					className: '-=on-scroll'
				})
				.set('.carousel--jumbotron, .fancybox-shadow', {
					className: '-=active'
				})
				.play();
		},
		onUpdate: function(instance, current) {
			var width,
				height,
				ratio = 16 / 9,
				video = current.$content;

			if (video) {
				video.hide();

				width  = current.$slide.width();
				height = current.$slide.height() - 100;

				if (height * ratio > width) {
					height = width / ratio;
				} else {
					width = height * ratio;
				}

				video.css({
					width : width,
					height: height
				}).show();
			}
		}
	});

});